import React from "react";
import Header from "./Comman/Header";
import Footer from "./Comman/Footer";

export default function TermsConditions() {
  return (
    <>
      <Header />
      <div className="tp-award-area pt-150 pb-125">
        <div className="container container-1630">
          <div className="row">
            <div className="col-xl-12">
              <div className="tp-service-5-title-box text-center">
                <h3 className="tp-hero-3-title tp_reveal_anim ">
                  Terms & Conditions – Kryptogram NFTs
                </h3>
              </div>
            </div>
          </div>
          <div className="row justify-content-center pt-80">
            <div className="col-xl-10 col-lg-10 col-md-12">
              <div className="tp-award-list-wrap">
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-2"
                >
                  <div className="  align-items-center">
                    <h2 className="text-yellow-new">Introduction</h2>
                    <p>
                      These Terms & Conditions govern your purchase, ownership,
                      and use of Kryptogram NFTs. By accessing our platform and
                      acquiring Kryptogram NFTs, you agree to these terms.
                    </p>
                    <p>
                      Kryptogram NFTs are digital collectibles that provide
                      exclusive utilities, including land ownership and festival
                      access. Purchasing 5 NFTs in a single transaction grants
                      land ownership rights on Kryptogram Island (USA). Owning 1
                      NFT provides entry to Tribe O Crypto Festival.
                    </p>
                  </div>
                </div>
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-3"
                >
                  <div className="  align-items-center">
                    <h2 className="text-yellow-new">Eligibility</h2>
                    <p>
                      To buy a Kryptogram NFT, you must: Be at least 18 years
                      old. Own a supported crypto wallet (e.g., MetaMask, Trust
                      Wallet, Coinbase Wallet). Use verified cryptocurrency
                      funds for transactions.
                    </p>
                  </div>
                </div>
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-4"
                >
                  <div className="  align-items-center">
                    <h2 className="text-yellow-new">NFT Ownership & Usage</h2>
                    <p>
                      Ownership Rights: Buying an NFT grants digital asset
                      ownership, but not trademark or branding rights. Final
                      Transactions: Due to blockchain immutability, all
                      purchases are final and irreversible. Resale & Transfers:
                      Kryptogram NFTs can be resold or transferred on supported
                      NFT marketplaces.
                    </p>
                  </div>
                </div>
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-4"
                >
                  <div className="  align-items-center">
                    <h2 className="text-yellow-new">
                      {" "}
                      Land Ownership on Kryptogram Island
                    </h2>
                    <p>
                      5 NFTs in a single transaction = 100 sq. ft. of land on
                      Kryptogram Island. Land is linked to the NFT and is not
                      separately transferable. Owners will receive a
                      blockchain-verified digital deed. Resale: Land rights can
                      be transferred by selling the associated NFTs.
                    </p>
                  </div>
                </div>
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-4"
                >
                  <div className="  align-items-center">
                    <h2 className="text-yellow-new">
                      Tribe O Crypto Festival Access
                    </h2>
                    <p>
                      1 NFT = Standard Festival Entry. 200 SuperElite NFTs = VIP
                      Festival Access (with helicopter transfers, premium
                      seating, and private lounges). NFTs serve as festival
                      tickets; no separate physical tickets are issued. No
                      Refunds for Non-Attendance.
                    </p>
                  </div>
                </div>
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-4"
                >
                  <div className="  align-items-center">
                    <h2 className="text-yellow-new">Payment & Refund Policy</h2>
                    <p>
                      Accepted Cryptocurrencies: ETH, USDT, BNB. Final Sales: No
                      refunds due to blockchain transaction finality.
                    </p>
                  </div>
                </div>
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-4"
                >
                  <div className="  align-items-center">
                    <h2 className="text-yellow-new">
                      Secondary Market Guidelines
                    </h2>
                    <p>
                      Kryptogram NFTs can be resold on any supported
                      marketplace. Land ownership remains valid if purchased
                      from a secondary market (subject to verification).
                      Kryptogram is not responsible for third-party
                      transactions.
                    </p>
                  </div>
                </div>
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-4"
                >
                  <div className="  align-items-center">
                    <h2 className="text-yellow-new">
                      Dispute Resolution Policy
                    </h2>
                    <p>
                      Any disputes will be handled through arbitration in
                      [Jurisdiction]. Users agree to resolve disputes through
                      mediation before legal action.
                    </p>
                  </div>
                </div>
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-4"
                >
                  <div className="  align-items-center">
                    <h2 className="text-yellow-new">Risk Disclaimer</h2>
                    <p>
                      NFT and cryptocurrency values are volatile. Kryptogram is
                      not responsible for financial losses due to market
                      fluctuations. Users must ensure their wallet security;
                      Kryptogram is not liable for wallet breaches.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
